export const strCurrentTabLink = 'customer-area-production-flow-current-tab-link';
export const strDeliveryFormKeyLocalStoragePageSize = 'customer-area-delivery-form-page-size';
export const strDeliveryFormKeyLocalStorageSort = 'customer-area-delivery-form-sort-favorite';
export const strDeliveryFormState = 'customer-area-delivery-form-state';
export const strFittingFormKeyLocalStoragePageSize = 'customer-area-fitting-form-page-size';
export const strFittingFormKeyLocalStorageSort = 'customer-area-fitting-form-sort-favorite';
export const strFittingFormState = 'customer-area-fitting-form-state';
export const strInvoiceKeyLocalStoragePageSize = 'customer-area-invoiced-delivery-form-page-size';
export const strInvoiceKeyLocalStorageSort = 'customer-area-delivery-form-invoice-sort-favorite';
export const strInvoiceState = 'customer-area-delivery-form-invoice-state';
export const strPeriodSearchTypeFavorite = 'customer-area-production-flow-period-search-favorite';
export const strProFormaKeyLocalStoragePageSize = 'customer-area-pro-forma-page-size';
export const strProFormaKeyLocalStorageSort = 'customer-area-delivery-form-pro-forma-sort-favorite';
export const strProFormaState = 'customer-area-delivery-form-pro-forma-state';
export const strQuoteKeyLocalStoragePageSize = 'customer-area-quote-page-size';
export const strQuoteKeyLocalStorageSort = 'customer-area-quote-sort-favorite';
export const strQuoteState = 'customer-area-quote-state';
